import * as actions from '../../constants/action-types';

export const validateRequiredStateData = () => ({
  type: actions.VALIDATE_REQUIRED_STATE_DATA,
});
